export const init = () => {
  const publicKey = cube.env.woosmapKey;
  $.getScript(
    'https://recommendation-js.woosmap.com/recommendation.js',
    () => {
      // init Woosmap recorecommandation
      window.woosmapRecommendation.setProjectKey(publicKey);
      window.woosmapRecommendation.getUserRecommendation({
        successCallback: stores => {
          // recommandation received : check and update store with API
          if (stores && stores.features && stores.features.length > 0) {
            // get first recommanded store_id
            const { store_id } = stores.features[0].properties;
            // save as Navigation Store
            cube.ajax
              .get(
                `/rest/model/atg/userprofiling/ProfileActor/setNavigationLocationId?navigationLocationId=${store_id}`
              )
              .onSuccess(() => cube.cartridge('header-store').reload())
              .call();
          }
        },
        limit: 1,
      });
    }
  );
};



// WEBPACK FOOTER //
// ./src/commons/header/recowoosmap.js